import colorPalette from '../color-palette';

const { text } = colorPalette;

export default {
  MuiInputLabel: {
    root: {
      paddingLeft: '11px',
      marginTop: '10px',
      fontWeight: 400,
      fontSize: '16px',
    },
    shrink: {
      marginTop: '-3px',
      paddingLeft: 0,
      color: text.primary,
    },
  },
};
